import request from '@/utils/request'

export function getv20a1000(param) {
    let data = param
    return request({
      url: `/v20/getv20a1000`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

 

  export function getShipDetail(param) {
    let data = param
    return request({
      url: `/v20/getShipDetail`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

 // chkShipPic
 export function chkShipPic(param) {
  let data = param
  return request({
    url: `/v20/chkShipPic`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

  export function getShipPic(param) {
    let data = param
    return request({
      url: `/v20/getShipPic`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  export function getEmpPic(param) {
    let data = param
    return request({
        url: `/v20/getEmpPic`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}